import React from "react";

// Ícones de linha do painel admin. Diferente dos demais ícones de src/img/svg (um por arquivo,
// cores fixas por prop), estes herdam a cor do texto (currentColor) para funcionarem tanto no
// menu escuro quanto nos cards claros, e ficam juntos por serem um conjunto visual único.

interface IIcon {
    width?: string;
    className?: string;
}

function Svg({ width = "20px", className = "", children }: IIcon & { children: React.ReactNode }) {
    return (
        <svg width={width} height={width} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" className={`shrink-0 ${className}`} aria-hidden="true">
            {children}
        </svg>
    )
}

export function HomeLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /><path d="M10 21v-6h4v6" /></Svg>
}

export function DashboardIcon(props: IIcon) {
    return <Svg {...props}><rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" /><rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" /></Svg>
}

export function MonitorIcon(props: IIcon) {
    return <Svg {...props}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></Svg>
}

export function HelpIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></Svg>
}

export function MegaphoneIcon(props: IIcon) {
    return <Svg {...props}><path d="m3 11 18-5v12L3 14v-3z" /><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" /></Svg>
}

export function UsersLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Svg>
}

export function ImageIcon(props: IIcon) {
    return <Svg {...props}><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" /><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21" /></Svg>
}

export function WatchLineIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="6" /><path d="M12 10v2l1 1" /><path d="m16.1 7.7-.8-4.1a2 2 0 0 0-2-1.6h-2.7a2 2 0 0 0-2 1.6l-.8 4.1" /><path d="m7.9 16.4.8 4a2 2 0 0 0 2 1.6h2.7a2 2 0 0 0 2-1.6l.8-4.1" /></Svg>
}

export function StarLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M12 2.5 15 8.6l6.7 1-4.9 4.7 1.2 6.7L12 17.8 6 21l1.2-6.7-4.9-4.7 6.7-1L12 2.5z" /></Svg>
}

export function FileTextIcon(props: IIcon) {
    return <Svg {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M16 13H8M16 17H8M10 9H8" /></Svg>
}

export function UserSearchIcon(props: IIcon) {
    return <Svg {...props}><circle cx="10" cy="7" r="4" /><path d="M10.3 15H7a4 4 0 0 0-4 4v2" /><circle cx="17" cy="17" r="3" /><path d="m21 21-1.9-1.9" /></Svg>
}

export function IdCardIcon(props: IIcon) {
    return <Svg {...props}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="M15 8h2M15 12h2M6.5 16a3 3 0 0 1 5 0" /></Svg>
}

export function ArrowLeftIcon(props: IIcon) {
    return <Svg {...props}><path d="m12 19-7-7 7-7" /><path d="M19 12H5" /></Svg>
}

export function ArrowRightIcon(props: IIcon) {
    return <Svg {...props}><path d="m12 5 7 7-7 7" /><path d="M5 12h14" /></Svg>
}

export function ChevronLeftIcon(props: IIcon) {
    return <Svg {...props}><path d="m15 18-6-6 6-6" /></Svg>
}

export function ChevronRightIcon(props: IIcon) {
    return <Svg {...props}><path d="m9 18 6-6-6-6" /></Svg>
}

export function MenuLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M4 6h16M4 12h16M4 18h16" /></Svg>
}

export function CloseIcon(props: IIcon) {
    return <Svg {...props}><path d="M18 6 6 18M6 6l12 12" /></Svg>
}

export function SearchLineIcon(props: IIcon) {
    return <Svg {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Svg>
}

export function CheckLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M20 6 9 17l-5-5" /></Svg>
}

export function PlusLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M12 5v14M5 12h14" /></Svg>
}

export function TrashIcon(props: IIcon) {
    return <Svg {...props}><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" /></Svg>
}

export function RefreshIcon(props: IIcon) {
    return <Svg {...props}><path d="M21 12a9 9 0 0 1-15.5 6.2L3 16" /><path d="M3 12a9 9 0 0 1 15.5-6.2L21 8" /><path d="M21 3v5h-5M3 21v-5h5" /></Svg>
}

export function ExternalLinkIcon(props: IIcon) {
    return <Svg {...props}><path d="M15 3h6v6" /><path d="M10 14 21 3" /><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /></Svg>
}

export function PencilIcon(props: IIcon) {
    return <Svg {...props}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" /></Svg>
}

export function InfoIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="M12 16v-4M12 8h.01" /></Svg>
}

export function AlertIcon(props: IIcon) {
    return <Svg {...props}><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></Svg>
}

export function CheckCircleIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></Svg>
}

export function XCircleIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="m15 9-6 6M9 9l6 6" /></Svg>
}

export function UploadIcon(props: IIcon) {
    return <Svg {...props}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m17 8-5-5-5 5" /><path d="M12 3v12" /></Svg>
}

export function LockIcon(props: IIcon) {
    return <Svg {...props}><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></Svg>
}

export function MailLineIcon(props: IIcon) {
    return <Svg {...props}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></Svg>
}

export function PhoneLineIcon(props: IIcon) {
    return <Svg {...props}><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z" /></Svg>
}

export function GlobeIcon(props: IIcon) {
    return <Svg {...props}><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z" /></Svg>
}

export function SortIcon(props: IIcon) {
    return <Svg {...props}><path d="m7 15 5 5 5-5" /><path d="m7 9 5-5 5 5" /></Svg>
}
